import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "search",
})
export class SearchPipe implements PipeTransform {
  transform(value: any[], arg: any): any {
    if (value !== undefined) {
      const result = [];
      for (const element of value) {
        if (element.group.name.toLowerCase().indexOf(arg.toLowerCase()) > -1) {
          result.push(element);
        }
      }
      return result;
    }
  }
}
